var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row col-12"},[_c('div',{staticClass:"col-12"},[_c('DatosTematica',{attrs:{"dataTematica":_vm.tematica,"dataVerticales":_vm.dataVerticales},on:{"saveData":_vm.setData,"validationError":_vm.haveError}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }